/**
 * Where the app lives, as printed on a login strip (spec 10.1) — the address a child types
 * into a browser. `VITE_APP_URL` overrides it; the default is the pilot's Pages URL (build
 * spec §1). Shown without a scheme, because that is how it goes on paper.
 */

const DEFAULT_APP_URL = "scrolivo.pages.dev";

export const APP_URL: string = (
  (import.meta.env["VITE_APP_URL"] as string | undefined) ??
  (typeof window === "undefined" ? DEFAULT_APP_URL : window.location.host)
).replace(/^https?:\/\//, "");
